<script>import { okhsl } from "../../d3-mapp/color/index.js";
export let color;
export let type = "square";
export let x = 0;
export let y = 0;
export let size = "1rem";
export let width = size;
export let height = size;
export let borderRadius = 0.25;
export let out = "html";
$:
  cssHeight = typeof height === "string" ? height : `${height}px`;
$:
  csswidth = typeof width === "string" ? width : `${width}px`;
$:
  _borderRadius = type === "circle" ? "50%" : out === "svg" ? borderRadius * height : typeof borderRadius === "number" ? `calc( ${height} * ${borderRadius} )` : borderRadius;
$:
  _color = typeof color === "string" ? okhsl(color) : color;
</script>

{#if out === "html"}<div
    class={type}
    style={`width:${width}; height:${height}; border-radius:${_borderRadius}; background-color:${_color.formatHex8()};`}
  />{:else}<rect
    {x}
    {y}
    {width}
    {height}
    rx={type === "square" ? _borderRadius : "50%"}
    fill={_color.formatHex()}
    fill-opacity={_color.opacity}
  />{/if}

<style>
  div {
    display: inline-block;
  }
</style>
